import ProfilePhoto from '../UI/profilePhoto';
import {useContext} from 'react';
import { FaRegUser, FaRegBookmark,FaRegEdit,FaCaretSquareRight ,FaRegAddressBook} from 'react-icons/fa';
import { FiVideo,FiPhone } from "react-icons/fi";
import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import { Link } from 'react-router-dom';

const SideNav = (props) => {
    
    const profileData = useContext(BioContext);
    const theme = useContext(ThemeContext);

    return ( 
        <div className="overlay" onClick={props.toggleSideNav}>
            <nav className="sidenav-container" style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>

                <ProfilePhoto className="profileIcon dp-sideNav" />
                <div>
                    <h3 className="profile-name">{profileData.GeneralInfo.name}</h3>
                    <p className="profile-title">{profileData.GeneralInfo.designation}</p>
                </div>
              

                <h3><Link style={{textDecoration: 'none',background: theme.currentTheme.background, color: theme.currentTheme.foreground}} to="/" id="lnk-profile"><span className="sideNavIcon"><FaRegUser size={15}/></span>Profile</Link></h3>
                <h3><a style={{textDecoration: 'none',background: theme.currentTheme.background, color: theme.currentTheme.foreground}} href="https://blog.shahbazkhan.in/" id="lnk-blogs"><span className="sideNavIcon"><FaRegEdit size={15}/></span>Blogs</a></h3>
                <h3><Link style={{textDecoration: 'none',background: theme.currentTheme.background, color: theme.currentTheme.foreground}} to="/projects" id="lnkprojects"><span className="sideNavIcon"><FaRegBookmark size={15}/></span>Projects</Link></h3>
                <h3><Link style={{textDecoration: 'none',background: theme.currentTheme.background, color: theme.currentTheme.foreground}} to="/videos" id="lnk-videos"><span className="sideNavIcon"><FiVideo size={17}/></span>Videos</Link></h3>
                <h3><Link style={{textDecoration: 'none',background: theme.currentTheme.background, color: theme.currentTheme.foreground}} to="/contact" id="lnk-contact"><span className="sideNavIcon"><FiPhone size={17}/></span>Contact</Link></h3>
                
            </nav>
        </div>
     );
}
 
export default SideNav;